import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { translationsWithFallback } from "helpers/utils";
import { t } from "i18next";
import { toast } from "react-toastify";

import type { TFetchStatus } from "./types";

interface SlackPayload {
    blocks: {
        type: string;
        text: {
            type: string;
            text: string;
            emoji?: boolean;
        };
    }[];
}

export const sendPaywallDemand = createAsyncThunk(
    "slack/sendPaywallDemand",
    async (payload: SlackPayload, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                import.meta.env.REACT_APP_API_ENDPOINT + `/beneficiary/ask-portal`,
                payload,
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

export interface SlackState {
    paywalDemandStatus: TFetchStatus;
}

const initialState: SlackState = {
    paywalDemandStatus: "idle",
};

export const slackSlice = createSlice({
    name: "slack",
    initialState,
    reducers: {
        setPaywallDemandStatus(state, action) {
            state.paywalDemandStatus = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(sendPaywallDemand.rejected, (state, { payload }) => {
            state.paywalDemandStatus = "failed";
            const translation = translationsWithFallback((payload as any)?.message, "ServerError.InternalServerError");
            toast.error(`${translation}`, { toastId: "ServerError.InternalServerError" });
        });
        builder.addCase(sendPaywallDemand.fulfilled, (state, action) => {
            state.paywalDemandStatus = "succeeded";
            toast.success(`${t("Beneficiars.PaywallInvitation.SlackDemandSuccess")}`);
        });
        builder.addCase(sendPaywallDemand.pending, (state, action) => {
            state.paywalDemandStatus = "pending";
        });
    },
});

export const { setPaywallDemandStatus } = slackSlice.actions;
export default slackSlice.reducer;
